module.exports = __webpack_public_path__ + "static/media/LightBgImage.92bf1ceb.png";